import { request } from 'utils/request';

import * as Types from 'types';

import { ResponseArtwork, mapResponseArtworkToArtwork } from 'features/artworks/api';

type ResponseCertificate = {
  id: number;
  state_updated_at_ms: number;
  image_url: string;
  purchase_price: number;
  transaction_hash?: string;
  owner_address?: string;
};

type ResponseEdition = {
  id: number;
  edition_number: number;
  purchase_price: number;
  artwork: ResponseArtwork;
  certificate: ResponseCertificate;
};

const mapEditionResponseToEdition = (response: ResponseEdition): Types.Edition => ({
  id: response.id,
  editionNumber: response.edition_number,
  artworkId: response.artwork.id,
  certificate: {
    id: response.certificate.id,
    imageUrl: response.certificate.image_url,
    updatedAt: response.certificate.state_updated_at_ms,
    purchasePrice: response.certificate.purchase_price,
    transactionHash: response.certificate.transaction_hash,
    ownerAddress: response.certificate.owner_address,
  },
});

const mapEditionResponseToArtwork = (response: ResponseEdition): Types.Artwork =>
  mapResponseArtworkToArtwork(response.artwork);

export const requestEdition = (editionId: number) =>
  request
    .get<ResponseEdition>(`/api/internal/editions/${editionId}.json`)
    .then(({ data }) => mapEditionResponseToEdition(data));

export const requestCurrentUserEditions = (): Promise<{
  editions: Types.Edition[];
  artworks: Types.Artwork[];
}> =>
  request.get<ResponseEdition[]>('/api/internal/editions.json').then(({ data }) => ({
    editions: data.map(mapEditionResponseToEdition),
    artworks: data.map(mapEditionResponseToArtwork),
  }));
